import { IncidentDetailCard } from "./IncidentDetailCard";
import type { IncidentDetailCardRecord } from "../model/incidentTypes";
import { useIncidentCarouselState } from "../hooks/useIncidentCarouselState";

type IncidentDetailsCarouselProps = {
  cards: IncidentDetailCardRecord[];
};

export function IncidentDetailsCarousel({ cards }: IncidentDetailsCarouselProps) {
  const { safeIndex, hasCards, goPrevious, goNext, handleKeyDown } = useIncidentCarouselState(cards.length);

  const activeCard = cards[safeIndex] ?? null;

  return (
    <article
      className="box incident-details-carousel fade-in"
      tabIndex={hasCards ? 0 : -1}
      onKeyDown={handleKeyDown}
      aria-label="Incident Details carousel. Use left and right arrow keys to navigate cards."
    >
      <div className="card-accent" aria-hidden="true" />
      <div className="incident-carousel__header">
        <h3>Atrocity Incident Details</h3>
        {hasCards ? <span className="small-meta">{safeIndex + 1} / {cards.length}</span> : null}
      </div>

      {hasCards && activeCard ? (
        <>
          <IncidentDetailCard card={activeCard} />
          <div className="incident-carousel__controls">
            <button type="button" className="secondary-button is-inline" onClick={goPrevious} aria-label="Previous incident card">
              Previous
            </button>
            <button type="button" className="secondary-button is-inline" onClick={goNext} aria-label="Next incident card">
              Next
            </button>
          </div>
        </>
      ) : (
        <p className="small-paragraph">No detailed incidents are available for this survivor yet.</p>
      )}
    </article>
  );
}
